import React from 'react'

const ORIGENES = [
  { id: 'ORDEN_COMPRA', label: 'Orden de Compra', habilitado: true }
]

const OrigenStrip = ({ origen, onChange }) => {
  return (
    <div
      style={{
        background: '#F0F4FF',
        border: '1px solid #D8E1F7',
        borderRadius: 4,
        padding: '10px 14px',
        marginBottom: 16,
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        flexWrap: 'wrap'
      }}
    >
      <span
        style={{
          fontSize: 11,
          fontWeight: 700,
          color: '#3B4276',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          whiteSpace: 'nowrap'
        }}
      >
        Origen del Ingreso
      </span>
      <div style={{ display: 'flex', gap: 6, flex: 1, flexWrap: 'wrap' }}>
        {ORIGENES.map(o => {
          const activo = origen === o.id
          return (
            <button
              key={o.id}
              type='button'
              disabled={!o.habilitado}
              onClick={() => o.habilitado && onChange && onChange(o.id)}
              title={!o.habilitado ? 'Próximamente disponible' : ''}
              style={{
                padding: '6px 14px',
                fontSize: 12,
                fontWeight: 600,
                color: activo ? '#fff' : !o.habilitado ? '#9CA3AF' : '#6B7280',
                background: activo ? '#5B5BD6' : '#fff',
                border: `1px solid ${activo ? '#5B5BD6' : '#CED4DC'}`,
                borderRadius: 16,
                cursor: o.habilitado ? 'pointer' : 'not-allowed',
                opacity: o.habilitado ? 1 : 0.6,
                fontFamily: 'inherit',
                transition: 'all 0.15s'
              }}
            >
              {o.label}
              {!o.habilitado && (
                <span
                  className='ml-1'
                  style={{
                    background: '#9CA3AF',
                    color: 'white',
                    fontSize: 8,
                    fontWeight: 700,
                    padding: '1px 4px',
                    borderRadius: 2,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}
                >
                  Pronto
                </span>
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default React.memo(OrigenStrip)
